import styled from "styled-components";

export const ScrollableContainer = styled.div`
  max-height: ${(props) => props.$maxHeight};
  min-height: 0;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ScrollContent = styled.div`
  padding-right: 8px;
  display: flex;
  flex-direction: column;
`;
